import {HeaderMall9} from "../../../../publicComponent/Header";
import Navigator from "../../../../publicComponent/h5/Navigator";
import FooterMall9 from "../../../../publicComponent/Footer/FooterMall9";
import CountControl from "../../components/CountControl";
import Button from "../../../../publicComponent/Button";
import CheckBox from "../../components/CheckBox";
import {calc, mediaMatch} from "../../../../utils";
import CartContext, {CartController, useCartContext} from "../../../../reducer/moduleReducer/cart";
import {useEffect} from "react";
import Buffer from "../../../../publicComponent/Buffer";
import {getI18n, useTranslation} from "react-i18next";


function BillCart() {
  const isMdmax = mediaMatch.isMdmax;
  const { checkout, getBillData } = CartController();
  const billData = getBillData();
  const { t } = useTranslation();
  
  return (
    <div className="mdmax:flex-1">
      <div className="mdmax:mx-[15px]">
        <div className="grid grid-cols-2 container md:mb-[20px] mb-[15px]">
          <p className="text-[#aaa]">{t('数量')}</p>
          <p className="text-right">{billData.quantity}</p>
        </div>
        
        <div className="grid grid-cols-2 container md:mb-[20px] mb-[15px]">
          <p className="text-[#aaa]">{t('商品总价')}</p>
          <p className="text-right">${billData.price}</p>
        </div>
        
        <div className="grid grid-cols-2 container">
          <p className="text-[#aaa] text-[14px]">{t('应付总额')}</p>
          <p className="text-right text-[20px] font-bold">
            ${calc.add(billData.price + billData.transportPreferPrice)}
          </p>
        </div>
      </div>
      <div className="pt-[30px] md:pb-[53px] pl-[60px]">
        <Button className="bg-[#333] mdmax:bg-[#ECBC40] text-[14px] text-white mdmax:text-[#333] w-[100%] py-[12px] rounded-l-full md:rounded-none relative font-bold md:px-[80px]"
                onClick={checkout}
                style={{ boxShadow: isMdmax ? 'none' : '0 3px 6px rgba(0,0,0,.16)' }}>
          {t('现在购买')}
          <i className="iconfont icon-right text-[14px] absolute right-[20px] md:text-white"/>
        </Button>
      </div>
    </div>
  );
}

function Goods({ item }) {
  const { checkedHandle, uploadGoods, countHandle, removeGoods } = CartController();
  const isMdmax = mediaMatch.isMdmax;
  const { handle } = countHandle(item, uploadGoods);
  const { t } = useTranslation();
  const lang = getI18n().language;
  
  return (
    <>
      <div className="mdmax:rounded-[10px] bg-white relative flex mdmax:hidden
                    mdmax:mb-[8px] mdmax:p-[12px] md:py-[18px] md:ml-[22px]">
        <div className="flex items-center">
          <CheckBox onClick={() => checkedHandle(item)} checked={item.checked}
                    className={'mr-[12px] mdmax:mr-[8px]'}/>
        </div>
        <div className="w-[160px] h-[160px] mdmax:w-[75px] mdmax:h-[75px] mr-[25px]">
          <img src={item.mainPic} style={{ width: '100%', height: '100%' }}/>
        </div>
        <div className="border-b flex flex-1">
          <div className="flex flex-col justify-between flex-1">
            <div className="flex-1 pr-[50px]">
              <p className="xl:text-[18px] line-clamp-2 text-[15px] mdmax:text-[14px] mdmax:font-bold">{lang === 'en'?item.itemEnName:item.itemName}</p>
              <p className="text-[14px] mdmax:text-[12px] my-[3px] text-[#999]">
                {t('规格')}：{item.specName}
              </p>
            </div>
          </div>
          <div className="flex-none w-[180px] px-[24px]">
            <p className="text-[#333] text-[16px] font-bold md:hidden">${item.price}</p>
            <CountControl count={item.quantity}
                          initCount={item.quantity}
                          addCount={handle}
                          subCount={handle}
                          goods={item}/>
          </div>
          <div className="flex-none w-[12%] text-right relative">
            <p className="text-[16px] mdmax:text-[12px] mb-[15px] mdmax:hidden">${item.price}</p>
            <i onClick={() => removeGoods(item)}
               className="iconfont icon-delete cursor-pointer absolute
                    text-[#999] text-[16px] right-[12px] bottom-[15px] mdmax:top-[12px]"/>
          </div>
        </div>
      </div>
      
      <div className="md:hidden flex relative clearfix md:mb-[45px] mb-[20px] mx-[15px]">
        <div className="flex items-center">
          <CheckBox iconColor={'#fff'}
                    onClick={() => checkedHandle(item)} checked={item.checked}
                    className="mr-[12px] mdmax:mr-[8px]"/>
        </div>
        <div className="flex-none rounded-[12px] overflow-hidden w-[80px] h-[80px] mr-[12px]">
          <img src={item.mainPic} style={{ width: '100%', height: '100%' }}/>
        </div>
        <div className="flex-1 pt-[5px] pr-[32px] clearfix">
          <p className="text-[13px] mb-[10px]">{lang === 'en'?item.itemEnName:item.itemName}</p>
          <p className="text-[#aaa]">${item.price}</p>
          <div className="w-[110px] absolute right-0 bottom-0">
            <CountControl count={item.quantity}
                          initCount={item.quantity}
                          addCount={handle}
                          subCount={handle}
                          goods={item}/>
          </div>
        </div>
        <i onClick={() => removeGoods(item)}
           className="iconfont icon-delete text-[16px] text-[#aaa] absolute right-0 top-0"/>
      </div>
    </>
  );
}

function CheckedAllBar() {
  const { checkedHandle } = CartController();
  const { state } = useCartContext();
  const { t } = useTranslation();
  
  return (
    <div className="border-b p-[10px] mdmax:hidden">
      <div className="text-[15px] cursor-pointer flex items-center w-[120px] select-none"
           onClick={() => checkedHandle('all')}>
        <CheckBox checked={state.checkedAll} className="mr-[12px]"/>
        <span>{t('全选')}</span>
      </div>
    </div>
  );
}

function CartWrap() {
  const { getCartList } = CartController();
  const { state, checkedHandle, uploadGoods } = useCartContext();
  const { cartList, billData, loading } = state;
  const { t } = useTranslation();
  const isMdmax = mediaMatch.isMdmax;
  
  useEffect(() => {
    getCartList();
  }, []);
  
  const innerHeight = isMdmax ? { height: window.innerHeight - 99 } : {};
  
  return (
    <div className="relative"
         style={innerHeight}>
      {cartList.length > 0 && <CheckedAllBar/>}
      <div className="relative">
        <Buffer.Loading loading={loading}/>
        <div className="md:m-[16px]">
          <div className="pb-[20px]">
            {
              cartList.length > 0
                ? cartList.map((item, i) => (
                  <div key={i} className="md:mt-[10px]">
                    <h1 className="text-[14px] font-bold px-[15px] py-[12px]">{item.shopName}</h1>
                    {
                      item.goodsList.map((goods, index) => (
                        <Goods checkedHandle={checkedHandle}
                               uploadGoods={uploadGoods}
                               initPage={() => null}
                               item={goods}
                               key={index}/>
                      ))
                    }
                  </div>
                
                ))
                : <Buffer.Empty content={t('抱歉！暂时还没有商品')}/>
            }
          </div>
          {
            cartList.length > 0 &&
            <div className="flex">
              <div className="flex-1 mdmax:hidden"></div>
              <BillCart data={billData} cartList={cartList}/>
            </div>
          }
        </div>
      </div>
    </div>
  );
}

export default function Cart() {
  const { t } = useTranslation(
  
  );
  return (
    <div className="mdmax:pb-[50px]">
      <HeaderMall9/>
      <Navigator title="购物车" noBorder/>
      <CartContext>
        <Navigator.container>
          <h1 className="font-bold text-[24px] my-[30px] mb-[15px] mdmax:hidden">
            {t('购物清单')}
          </h1>
          <CartWrap></CartWrap>
        </Navigator.container>
      </CartContext>
      <FooterMall9/>
    </div>
  );
}
